<template>
  <div class="mb-4">
    <validation-provider :rules="{ required: !isOptional }" :disabled="isOptional" v-slot="{ errors }" :immediate="validateImmediate">
      <h6 v-if="displayError(errors, number + question.questionText)" class="text-danger">{{ errors[0] }}</h6>
      <div class="mb-1" :style="{ 'background-color': questionBackColor }"><span v-html="number" class="number-text"></span><span v-html="question.questionText"></span></div>
      <div v-html="question.instructions" class="font-italic mb-1"></div>
      <div v-if="debugQuestions" class="text-warning">{{ isOptional }} {{ question.hspCategoryQuestionId }} (state text: {{ stateResponseTextValue }}))</div>
      <base-input
        :responsesBackColor="responsesBackColor"
        :value="stateResponseTextValue"
        :isMultiline="isMultiline"
        :maxLength="max"
        :readonly="readonly"
        :textAlign="textAlign"
        :fontSize="fontSize"
        :fontWeight="fontWeight"
        @input="handleInput"></base-input>
      <div v-if="isMultiline && max">Characters Left: {{ charactersLeft }}</div>
    </validation-provider>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';

export default {
  components: {
    ValidationProvider
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    number: String,
    questionBackColor: String,
    responsesBackColor: String,
    sectionId: {
      type: Number,
      required: true,
      description: 'Needed to disable validation when section is not active.'
    },
    validateImmediate: Boolean,
  },
  data() {
    return {
      value: null,
      max: undefined,
      readonly: false,
      textAlign: "left",
      fontSize: null, // null or approximately '0.8575em' is normal size.
      fontWeight: null, // null or 'normal' is normal font weight.
    }
  },
  computed: {
    ...mapGetters(['activeSectionId', 'debugQuestions']),
    isDisplayed() {
      return this.sectionId === this.activeSectionId;
    },
    isOptional() {
      if(this.isDisplayed && this.question.isRequired === true) {
        return false;
      }

      return true;
    },
    stateResponseTextValue() {
      let responses = this.$store
        .getters
        .getQuestionResponses(this.question.hspCategoryQuestionId)

      if(responses.length) {
        return responses[0].responseTextValue;
      }

      return null;
    },
    isMultiline() {
      return this.question.hspQuestionTypeId === 4;
    },
    charactersLeft() {
      if(this.stateResponseTextValue) {
        return this.max - this.stateResponseTextValue.length;
      }

      else return this.max;
    }
  },
  methods: {
    displayError(error, description = "") {
      let display = error.length > 0 && error[0].length > 0;
      // console.log("In TextInput.vue -- error:");
      // console.log(error);
      // console.log((description.length > 0 ? "for [" + description + "]: " : "") + "display = [" + display + "]");
      return display;
    },
    handleInput: function(value) {
      this.$store.dispatch('setQuestionResponse', {
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseText: value
      });
    }
  },
  created() {
    this.question.questionOptions.forEach(option => {
      if(this.hasOwnProperty(option.optionName)) {
        this[option.optionName] = option.optionValue;
      }
    });
  },
}
</script>
